module.exports = __webpack_public_path__ + "static/media/2.f808a90a.png";